import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton } from '@mui/material';

import useLocales from '../../../hooks/useLocales';
import Iconify from '../../../components/Iconify';
import { setActiveTab } from '../../../redux/slices/game';
import { useDispatch } from '../../../redux/store';
import AddBank from '../../../assets/withdraw/add_bank_icon.png';

const NonRootHeader = ({ label, isClose, isTransparent, addBank = false, onAddBankClick }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { translate } = useLocales();

  return (
    <>
      <Box sx={{ height: "58px" }}/>
      <Box
        sx={{
          // height: '64px',
          background: isTransparent ? 'transparent' : '#fff',
          position: 'fixed',
          top: 0,
          zIndex: 2,
          width: "100%",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          // marginBottom: 2,
          p: 2,
        }}
      >
        {isClose ? (
          <IconButton
            onClick={() => {
              dispatch(setActiveTab('Home'));
              navigate('/');
            }}
            sx={{ position: 'absolute', left: 8 }}
          >
            <Iconify icon={'ep:close-bold'} />
          </IconButton>
        ) : (
          <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 8 }}>
            <Iconify icon="material-symbols:arrow-back-ios-new-rounded" />
          </IconButton>
        )}
        <Typography variant="h6" fontWeight={700}>
          {translate(label)}
        </Typography>
        {addBank && (
          <IconButton onClick={onAddBankClick} sx={{ position: 'absolute', right: 8 }}>
            <Box component="img" src={AddBank} alt="add bank" sx={{ width: 24, height: 24 }} />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export default NonRootHeader;
